<template>
  <div>
    <div>名称：{{info.name}}</div>
    <div>地址：{{info.address}}</div>
    <div>联系电话：{{info.phone}}</div>
    <!-- <div>经营范围：{{info.businessRange}}</div> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SendMessage, companyByid } from "@/api/websocket.js";
export default {
  props: ['info'],
  methods: {
  }
};
</script>
<style lang="less" scoped>
</style>
